import React, { Fragment } from 'react';

const HelpItem6 = () => {
    return (
        <Fragment>
            <p className='p'>
                When you select the associate page.  A list of associates will be listed.
            </p>
            <p className='p'>
                Each associate with have a link to the restaurant they work for. Clicking on the restaurant name will give you the restaurant detail which includes menus, assocaites and entertainment items.
            </p>
            <p className='p'>
                The associates that are in will have a green dot on their photo.
            </p>
        </Fragment>
    );
};

export default HelpItem6;